// extracted by mini-css-extract-plugin
export default {"actions":"UnitsTable_actions_gIT3M"};